export default __webpack_public_path__ + "static/media/mahiribooks.1924820d.png";